import { Alert, Snackbar, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { snackBarSX } from '@/components/content/Notifications/styles/snackbar';
import { useElementOffset } from 'integration/hooks/useElementOffset';

type SnackBarTopNotificationProps = {
	message: string;
	onClear: () => void;
	flow?: 'login' | 'register';
};

export const DpSnackUserAuthNotification: React.FC<SnackBarTopNotificationProps> = ({
	message,
	onClear,
}) => {
	const marginTop = useElementOffset('#header', 'bottom');

	const snackBarSXWithOffset = {
		...snackBarSX,
		top: marginTop > 0 ? `${marginTop - 16}px !important` : '24px !important',
	};

	return (
		<Snackbar
			open={!!message}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			autoHideDuration={5000}
			sx={snackBarSXWithOffset}
			onClose={onClear}
			ClickAwayListenerProps={{
				onClickAway: onClear,
				mouseEvent: 'onMouseDown',
			}}
		>
			<Alert
				severity="success"
				onClose={onClear}
				icon={false}
				sx={{
					backgroundColor: '#F0F7FF',
					color: '#357DD2',
					'& .MuiAlert-action': {
						color: '#357DD2',
					},
				}}
			>
				<Stack direction="row">
					<CheckCircleIcon sx={{ mr: 1 }} />
					<Typography sx={{ fontWeight: 800 }}>{`¡Hola, ${message}!`}</Typography>
				</Stack>
				<Typography>{'Iniciaste sesión correctamente'}</Typography>
			</Alert>
		</Snackbar>
	);
};
